import tokenService from "@/utils/tokenService";

class Api {
    private async getHeaders(): Promise<HeadersInit> {
        const token = await tokenService.getValidToken();

        const headers: Record<string, string> = {
            "Content-Type": "application/json",
        };

        if (token) {
            headers["Authorization"] = `Bearer ${token}`;
        }

        return headers;
    }

    private async handleResponse<T>(response: Response): Promise<T> {
        const data = await response.json();
        if (!response.ok) {
            // FastAPI returns errors in { detail: string } format
            const errorMessage =
                data.detail || `HTTP error! status: ${response.status}`;
            throw new Error(errorMessage);
        }
        return data;
    }

    async get<T>(endpoint: string): Promise<T> {
        const response = await fetch(endpoint, {
            method: "GET",
            headers: await this.getHeaders(),
        });
        return this.handleResponse<T>(response);
    }

    async post<T>(endpoint: string, data: any): Promise<T> {
        const response = await fetch(endpoint, {
            method: "POST",
            headers: await this.getHeaders(),
            body: JSON.stringify(data),
        });
        return this.handleResponse<T>(response);
    }

    async put<T>(endpoint: string, data: any): Promise<T> {
        const response = await fetch(endpoint, {
            method: "PUT",
            headers: await this.getHeaders(),
            body: JSON.stringify(data),
        });
        return this.handleResponse<T>(response);
    }

    async delete<T>(endpoint: string): Promise<T> {
        const response = await fetch(endpoint, {
            method: "DELETE",
            headers: await this.getHeaders(),
        });
        return this.handleResponse<T>(response);
    }
}

const api = new Api();

export default api;
